import { i18n } from '@shared/i18n';

const programSetting = {
  icon: 'icon-cup',
  title: i18n(`subpropertySettings.program.title`),
  subtitle: i18n(`subpropertySettings.program.subtitle`),
  route: { name: 'programSettings' },
  tooltipCaption: i18n(`subpropertySettings.program.tooltipCaption`),
  links: [],
};

const leagueSettings = {
  icon: 'icon-cup',
  title: i18n(`seasonSettings.league.title`),
  subtitle: i18n(`seasonSettings.league.subtitle`),
  route: { name: 'programSettings' },
  tooltipCaption: i18n(`seasonSettings.league.tooltipCaption`),
  links: [],
};

const finantialSetting = (propertyId, subpropertyId) => ({
  icon: 'icon-card',
  title: i18n(`subpropertySettings.finantial.title`),
  subtitle: i18n(`subpropertySettings.finantial.subtitle`),
  route: {
    name: 'finantialSettings',
    params: { propertyId, subpropertyId },
  },
  tooltipCaption: i18n(`subpropertySettings.finantial.tooltipCaption`),
  links: [],
});

const customizationSetting = {
  icon: 'icon-pen',
  title: i18n(`subpropertySettings.customize.title`),
  subtitle: i18n(`subpropertySettings.customize.subtitle`),
  route: { name: 'subpropertyCustomizeSettings' },
  tooltipCaption: i18n(`subpropertySettings.customize.tooltipCaption`),
  links: [],
};

export class SubpropertySettingsModel {
  static settings({ paymentsEnabled = false, propertyId, subpropertyId, isPropertyNBA } = {}) {
    const settings = [programSetting];
    if (paymentsEnabled) settings.push(finantialSetting(propertyId, subpropertyId));
    if (process.env.VUE_APP_DISABLE_SUBPROPERTY_CUSTOMIZATION === 'false') settings.push(customizationSetting);
    if (isPropertyNBA) return [leagueSettings];
    return settings;
  }
}
